import Button from 'components/base/Button';
import Modal, { ModalHandler } from 'components/base/Modal';
import Toast from 'components/Toast';
import classlist from 'utils/classlist';
import './style.scss';

export interface LinkModalProps {
    title: React.ReactNode;
    className?: string;
    noIcon?: boolean;
    // canExpandable为false和string时进行拦截。为true应该走正常流程
    canExpandable?: string | boolean | (() => string | boolean);
    onClick?: (ev?: React.MouseEvent) => void;
    // 如果传了此选项, 则点击的效果是打开一个弹窗
    modalOptions?: {
        // children是弹窗的整体内容, 如果需要完全自定义弹窗内展示内容的话(比如弹窗内需要内嵌表单), 就使用children, 比如开户流程中assets页面的w8的展示
        // modalContent是弹窗的描述性文案/内容, 会自动带上一个默认的按钮, 按钮点击关闭弹窗
        children?: React.ReactNode | ((props: ModalHandler) => React.ReactNode);
        modalContent?: React.ReactNode | ((props: ModalHandler) => React.ReactNode);
        btnOk?: string;
        btnOkCallback?: () => void;
        modalClassName?: string;
        backdrop?: boolean | 'static';
        dialogClassName?: string;
        centered?: boolean;
    };
}

const LinkExpand: React.FC<LinkModalProps> = props => {
    const { title, canExpandable, className, noIcon, modalOptions, onClick } = props;
    const {
        modalContent,
        btnOk = __('同意并返回'),
        children,
        btnOkCallback,
        modalClassName,
        backdrop = true,
        centered,
        dialogClassName
    } = modalOptions || {};
    const handleClick = () => {
        // undefined不做拦截
        if (typeof canExpandable !== 'undefined') {
            const result = typeof canExpandable === 'function' ? canExpandable() : canExpandable;
            const isString = typeof result === 'string';

            if (isString || result === false) {
                isString && Toast.show(result);

                return;
            }
        }

        if (modalOptions) {
            Modal.open({
                component: (props: ModalHandler) => (
                    <div className={classlist('link-modal-content px-2 px-sm-4 pt-3 pt-sm-4', modalClassName)}>
                        {children ? (
                            <div className="px-2 px-sm-0">
                                {typeof children === 'function' ? children(props) : children}
                            </div>
                        ) : (
                            <>
                                {!!modalContent && (
                                    <div className="px-2 px-sm-0 overflow-auto">
                                        {typeof modalContent === 'function' ? modalContent(props) : modalContent}
                                    </div>
                                )}
                                <div className="link-modal-btn-container py-3 bg-white">
                                    <Button onClick={() => props.close()} round className="agree-btn fw-bold">
                                        {btnOk}
                                    </Button>
                                </div>
                            </>
                        )}
                    </div>
                ),
                dialogClassName: classlist('link-modal-dialog', dialogClassName),
                backdrop,
                centered
            })
                .result.then(() => {
                    btnOkCallback?.();
                })
                .catch(() => {});
        } else {
            onClick?.();
        }
    };

    return (
        <div
            className={classlist(
                'link-modal-root fs-5',
                {
                    'no-icon': noIcon
                },
                className
            )}
            onClick={handleClick}>
            <div className="me-3">{title}</div>
        </div>
    );
};

export default LinkExpand;
